import { ModuleRegistry } from 'ag-grid-community';
import {
  ClientSideRowModelModule,
  CellStyleModule,
  CellApiModule,
  RowSelectionModule,
  ColumnApiModule,
  ColumnAutoSizeModule,
  CsvExportModule,
  CustomFilterModule,
  DateFilterModule,
  EventApiModule,
  ExternalFilterModule,
  NumberEditorModule,
  NumberFilterModule,
  PaginationModule,
  QuickFilterModule,
  RenderApiModule,
  RowApiModule,
  RowAutoHeightModule,
  RowStyleModule,
  ScrollApiModule,
  SelectEditorModule,
  TextEditorModule,
  TextFilterModule,
  UndoRedoEditModule,
  TooltipModule,
} from 'ag-grid-community';
import { LicenseManager } from 'ag-grid-enterprise';

// Import enterprise modules (excluding charts since we don't use them)
import {
  ColumnMenuModule,
  ContextMenuModule,
  ColumnsToolPanelModule,
  FiltersToolPanelModule,
  SetFilterModule,
  StatusBarModule,
  RangeSelectionModule,
  ClipboardModule,
  ValidationModule,
  ExcelExportModule,
  GroupFilterModule,
  MultiFilterModule,
  PivotModule,
  RowGroupingModule,
  RowGroupingPanelModule,
  ServerSideRowModelModule,
  ServerSideRowModelApiModule,
  ViewportRowModelModule,
} from 'ag-grid-enterprise';

export const setupAgGrid = () => {
  // Register AG Grid modules
  ModuleRegistry.registerModules([
    // Community modules
    ClientSideRowModelModule,
    CellStyleModule,
    CellApiModule,
    ColumnApiModule,
    ColumnAutoSizeModule,
    CsvExportModule,
    CustomFilterModule,
    DateFilterModule,
    EventApiModule,
    ExternalFilterModule,
    NumberEditorModule,
    NumberFilterModule,
    PaginationModule,
    QuickFilterModule,
    RenderApiModule,
    RowApiModule,
    RowAutoHeightModule,
    RowSelectionModule,
    RowStyleModule,
    ScrollApiModule,
    SelectEditorModule,
    TextEditorModule,
    TextFilterModule,
    TooltipModule,
    UndoRedoEditModule,

    // Enterprise modules
    ColumnMenuModule,
    ContextMenuModule,
    ColumnsToolPanelModule,
    FiltersToolPanelModule,
    SetFilterModule,
    StatusBarModule,
    RangeSelectionModule,
    ClipboardModule,
    ValidationModule,
    ExcelExportModule,
    GroupFilterModule,
    MultiFilterModule,
    PivotModule,
    RowGroupingModule,
    RowGroupingPanelModule,
    ServerSideRowModelModule,
    ServerSideRowModelApiModule,
    ViewportRowModelModule,
  ]);

  // Set license key
  const licenseKey = import.meta.env.VITE_AG_GRID_LICENSE_KEY;

  if (licenseKey) {
    LicenseManager.setLicenseKey(licenseKey);
    console.log('AG Grid Enterprise license registered');
  } else {
    console.warn('AG Grid running in evaluation mode - no license key provided');
  }
};
